import { faChevronRight, faLightbulb } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../shared/components/button/Button';
import useKeyboardAction from '../../shared/hooks/useKeyboardAction.ts';
import ProductivityTracker from './ProductivityTracker';

function ProductivityCover(props) {
  const { closeTrackers } = props;
  const { t } = useTranslation();

  const [areaPicker, setAreaPicker] = useState(true);
  const [openProductivity, setOpenProductivity] = useState(false);

  const handleProductivity = () => {
    const main = document.getElementById('snm-main');
    main?.classList.remove('slide-in');
    setTimeout(() => {
      setAreaPicker(false);
      setOpenProductivity(true);
    }, 500);
  };

  useKeyboardAction(() => {
    closeTrackers();
  }, 'Escape');

  useEffect(() => {
    if (openProductivity) {
      const productivity = document.getElementById('snm-productivity');
      setTimeout(() => {
        productivity?.classList.add('slide-in');
      }, 300);
    }
  }, [openProductivity]);

  useEffect(() => {
    if (areaPicker) {
      const main = document.getElementById('snm-main');
      setTimeout(() => {
        main?.classList.add('slide-in');
      }, 300);
    }
  }, [areaPicker]);

  const handleBackToMain = () => {
    if (openProductivity) {
      const productivity = document.getElementById('snm-productivity');
      productivity?.classList.remove('slide-in');
      setTimeout(() => {
        setOpenProductivity(false);
        setAreaPicker(true);
      }, 500);
    }
  };

  return (
    <>
      {areaPicker && (
        <div id="snm-main" className="tracker-container">
          <div className="ind-tracker mood">
            <h2 className="title">{t('T134')}</h2>
            <button
              className="mood-area"
              onClick={handleProductivity}
              type="button"
              aria-label={t('T357')}
            >
              <div>
                <FontAwesomeIcon icon={faLightbulb} className="mood-icon" /> {t('T357')}{' '}
              </div>
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
          <div className="buttons mood">
            <Button onClick={props.closeTrackers} variant="secondary" color="dark">
              {t('T015')}
            </Button>
          </div>
        </div>
      )}{' '}
      {openProductivity && (
        <ProductivityTracker
          handleBackToMain={handleBackToMain}
          closeTrackers={props.closeTrackers}
        />
      )}
    </>
  );
}
export default ProductivityCover;
